import {ChangeDetectorRef, Directive, ElementRef, Self} from '@angular/core';
import {NgModel} from '@angular/forms';
import {GridFilterDirective} from './grid-filter.directive';
import {AutoComplete, MultiSelect} from 'primeng/primeng';
import {ElementState} from '../../../services/element-state';
import {ChangeDetectorRefHelper} from '../../../../helpers/change-detector-ref.helper';

@Directive({
  selector: '[gridFilterAutoComplete]',
  host: {
    '(input)': 'onInput($event)',
    '(onChange)': 'onChange($event)',
    '(onSelect)': 'onSelect($event)',
    '(onUnselect)': 'onSelect($event)',
  },
  providers: [NgModel]
})
export class GridFilterAutoCompleteDirective extends GridFilterDirective {

  private readonly autocomplete: AutoComplete = null;
  public constructor(
    protected elementRef: ElementRef,
    protected ngModel: NgModel,
    public cdr: ChangeDetectorRef,
    @Self() autocomplete: AutoComplete
  ) {
    super(elementRef, ngModel, cdr);

    if (autocomplete) {
      this.autocomplete = autocomplete;
    }
  }

  public setValue(componentState: ElementState): void {
    const filterState = this.getFilter(componentState);

    if (this.autocomplete && filterState && filterState.value) {
      if (filterState.value instanceof Array) {
        this.autocomplete.writeValue(filterState.value);
      }

      if (filterState.stateValue && filterState.stateValue.value instanceof Array) {
        this.autocomplete.writeValue(filterState.stateValue.value);
      }

      ChangeDetectorRefHelper.detectChanges(this);
    }
  }
}
